import { render, staticRenderFns } from "./pointsOfSale.vue?vue&type=template&id=3e319695&scoped=true&"
import script from "./pointsOfSale.vue?vue&type=script&lang=js&"
export * from "./pointsOfSale.vue?vue&type=script&lang=js&"
import style0 from "./pointsOfSale.vue?vue&type=style&index=0&id=3e319695&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e319695",
  null
  
)

export default component.exports